import { useTaskImages } from "@coworker/apprestructured/src/task-management/services/useTaskImages";
import { useUploadFiles } from "@coworker/apprestructured/src/task-management/services/useUploadFiles";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";
import {
  UploadImageUrl,
  useUploadImageUrls,
} from "@coworker/apprestructured/src/task-management/services/helpers/useUploadImageUrls";

/**
 * Get object urls for all images in a given task.
 */
export function useTaskImageUrls(
  taskId: string | null
): UploadImageUrl[] | Loading {
  const { data: uploads } = useTaskImages(taskId);
  const uploadFiles = useUploadFiles(uploads);
  return useUploadImageUrls(uploadFiles);
}
